import ViewFactory from "../../../helpers/viewfactory";

export default function view() {
  const { $charge } = this;
  
  return (view = ViewFactory({
    NAME: 'NQR_INIT_VIEW',
    next() { $charge.init() }
  }).call(this));
}
